import React, { useRef, useState, useEffect } from 'react';
import WrapperWithRecovery from './WrapperWithRecovery';

const SimulationAvatar = ({ responseText, isPlaying, onPlayComplete, onPlayStart }) => {
  const [isAvatarHovered, setIsAvatarHovered] = useState(false);
  const avatarIframeRef = useRef(null);
  const audioRef = useRef(new Audio());

  useEffect(() => {
    const triggerAvatarStart = () => {
      if (avatarIframeRef.current) {
        try {
          const iframeDocument = avatarIframeRef.current.contentDocument ||
            (avatarIframeRef.current.contentWindow && avatarIframeRef.current.contentWindow.document);

          if (iframeDocument) {
            const possibleSelectors = [
              '.start-button', 'button', '[role="button"]',
              '.play-button', '#start', 'a.start', '.avatar-start',
            ];

            for (const selector of possibleSelectors) {
              const elements = iframeDocument.querySelectorAll(selector);
              for (const element of elements) {
                element.click();
              }
            }
          }
        } catch (e) {
          console.error("Could not auto-start avatar due to same-origin policy:", e);
        }
      }
    };

    const attempts = [500, 1000, 1500, 2000, 3000];
    const timeoutIds = attempts.map(delay => setTimeout(triggerAvatarStart, delay));

    if (avatarIframeRef.current) {
      avatarIframeRef.current.onload = triggerAvatarStart;
    }

    return () => timeoutIds.forEach(id => clearTimeout(id));
  }, []);

  useEffect(() => {
    return () => {
      if (audioRef.current) {
        audioRef.current.pause();
        audioRef.current.src = '';
      }
    };
  }, []);

  const handleAvatarPlay = async () => {
    if (onPlayStart) onPlayStart();
    
    // Audio playback logic would be implemented here
    // This would typically call the API service to convert text to speech
    // and then play the audio while animating the avatar
    
    // When audio finishes playing:
    if (onPlayComplete) onPlayComplete();
  };

  return (
    <div className="w-full h-[550px] bg-gray-50 rounded-lg overflow-hidden relative">
      <div
        className="relative flex items-center justify-center overflow-hidden rounded-lg h-full"
        onMouseEnter={() => setIsAvatarHovered(true)}
        onMouseLeave={() => setIsAvatarHovered(false)}
      >
        <WrapperWithRecovery
          settings={{
            AutoPlayVideo: true,
            AutoConnect: true,
            StartVideoMuted: false,
            ss: window.location.protocol === 'https:' ?
              "wss://18.208.58.92:8443" :
              "ws://18.208.58.92:30080",
            peerConnectionOptions: {
              iceServers: [
                {
                  urls: ["turn:18.208.58.92:3478"],
                  username: "user",
                  credential: "password"
                }
              ],
              iceTransportPolicy: "relay"
            },
            HoveringMouse: true,
            WaitForStreamer: true,
            HideUI: true,
            WebRTCMaxBitrate: 10000,
          }}
          ref={avatarIframeRef}
        />
        {!isPlaying && (isAvatarHovered) && (
          <button
            onClick={handleAvatarPlay}
            className="absolute left-1/2 top-1/2  bg-white border-none rounded-full w-12 h-12 shadow-md flex items-center justify-center cursor-pointer z-10"
            title="Play"
          >
            <svg width="24" height="24" viewBox="0 0 32 32">
              <circle cx="16" cy="16" r="16" fill="#fff" />
              <polygon points="12,9 26,16 12,23" fill="#1976d2" />
            </svg>
          </button>
        )}
        <audio 
          ref={audioRef} 
          onEnded={() => {
            if (onPlayComplete) onPlayComplete();
          }} 
        />
      </div>
    </div>
  );
};

export default SimulationAvatar;